import { FormulaBuilderConfig } from '../../cpq-formula-builder/cpq-formula-builder.model';
import { CpqNumberOptions } from '../../directives/validator/cpq-number-options.model';
import { ILookup } from './ILookup.interface';

export interface IColumn {
    name?: string;
    /**
     * If you want to be able to save
     * column visibility state,
     * prop has to be provided
     */
    prop?: string;
    /**
     * If sorting column does not exist on backend, we can use sortingProp instead.
     * Ex. if we want to sort by label like 'One, Two, Fifty Five', but we use values like '1, 2, 55' on backend, we would send property 'realNumber' together with property 'userFriendlyNumber'.
     * [{ userName: 'luka', ageLabel: 'FiftyFive', age: '55' }] -> { prop: 'ageLabel', sortingProp: 'age' }.
     * See attributes-data-table: column -> typeLabel.
     */
    sortingProp?: string;
    filteringProp?: string;
    cellType?: CellType;
    cellTemplate?: any;
    searchFieldType?: ColumnSearchFieldType;
    headerTemplate?: any;
    customHeaderTemplate?: any;
    searchValue?: string;
    dateFromSearchValue?: string;
    dateToSearchValue?: string;
    isSearchByPeriod?: boolean;
    editable?: boolean;
    /**
     * Checks if you want to display column on table and on gear button modal, false by default
     */
    visible?: boolean;
    /**
     * Checks if you don't want to display column neither on table or gear button modal
     */
    hidden?: boolean;
    /**
     * Checks if you can click a column to sort its content alphabetically, true by default
     */
    sortable?: boolean;
    /**
     * Checks if you can resize a column, true by default
     */
    resizeable?: boolean;
    /**
     * In pixels, Ex: 300,
     */
    width?: number;/**
    * In pixels, Ex: 300,
    */
    minWidth?: number;/**
    * In pixels, Ex: 300,
    */
    maxWidth?: number;
    $$oldWidth?: number;
    type?: ColumnType;
    hideInColumnSelection?: boolean;
    hideTooltip?: boolean;
    required?: boolean;
    /**
     * If you want to limit the length of the text in the cell
     * Ex: 3, it will allow only 3 characters when editing the cell
     */
    maxLength?: number;
    formulaBuilderConfig?: FormulaBuilderConfig;
    cellClass?: string;
    headerClass?: string;
    items?: Array<ILookup<number, string>> | Array<ILookup<string, string>>;
    numberOptions?: CpqNumberOptions;
    /**
     * Option values for select search field type
     * Data example: : [{id: 'S1', text: 'Simple'}, {id: 'C1', text: 'Config'}]
     */
    columnSearchItems?: Array<ILookup<number|string,string>>
    /**
     * Should search input be disabled
     */
    columnSearchDisabled?: boolean;
    /**
    * Column search info message
    */
    columnSearchInfoMessageKey?: string;
    url?: string;
}

export enum ColumnType {
    Number,
    Text,
    Boolean,
    Date,
    DatePicker,
    Dropdown,
    DateTime
}

export enum CellType {
    edit,
    toggle,
    checkbox,
    /**
     * If type is custom or actions, than cellTemplate must be provided
     */
    custom,
    actions,
    twoStateCellTmpl,
    default
}

export enum ColumnSearchFieldType {
  /**
   * no column search input (default option)
   */
  ngxDefaultHeader,
  /**
   * use select template yes/no options
   */
  twoState,
  /**
   * use select template
   */
  select,
  searchableSelect,
  date,
  number,
  text
}

export class ColumnSearchEventData {
    public column: IColumn;
    public searchText: string;
}
